/**
 * Setzt html.fonts-ready, sobald die Schriften stehen. Das Laufband startet erst dann, sonst
 * springt es, weil die Wörter mit der geladenen Schrift eine andere Breite bekommen.
 * Sicherheitsnetz: Nach einer Sekunde läuft es auf jeden Fall los, auch ohne Rückmeldung.
 */

const READY_CLASS = 'fonts-ready';
const FALLBACK_MS = 1_000;

export function startWhenFontsReady(): void {
  const mark = () => document.documentElement.classList.add(READY_CLASS);
  const timer = window.setTimeout(mark, FALLBACK_MS);
  const ready = document.fonts?.ready;
  if (!ready) return;
  void ready.then(() => {
    window.clearTimeout(timer);
    mark();
  });
}
